export default function replaceFrenchAccents(frenchString: string): string {
  return frenchString.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
